module.exports = __webpack_public_path__ + "static/media/webdesign-services-img26.db1830b0.jpg";